/*******************************************************
 ***************************************** Lokking for
 *******************************************************/

(function($, window, document, undefined) {
  'use strict';

  $.fn.scrollVideo = function () {


    $(this).each(function(){

      var $element = $(this);
      var elementOffsetTop = $element.offset().top;
      var elementHieght = $element.height();
      var winHeight = $(window).height();

      var isVisible = false;
      var isPlaying = false;

      // update size after window resize
      $(window).on('resize.toggle-video', function(e){
        winHeight = $(window).height();
        elementOffsetTop = $element.offset().top;
        elementHieght = $element.height();
      });


    //  controls


      var original = $element.data('original');
      if(!Modernizr.videoautoplay){
        $element.attr('controls', true);
      }
      $element.append($('<source src="' + original + '" type="video/mp4" />'));


      // start when element is visible
      $(document).on('scroll.toggle-video', function(){
        var scrollTop = $(document).scrollTop();

        /*
        if(scrollTop + winHeight > elementOffsetTop && isVisible === false){
          var original = $element.data('original');
          $element.append($('<source src="' + original + '" type="video/mp4" />'));
          isVisible = true;
        }
        */

    //    if(isVisible){
          if(scrollTop > elementOffsetTop - (winHeight * 0.4) && scrollTop < elementOffsetTop + (elementHieght * 0.5)  && isPlaying === false){
            $element[0].play();
            isPlaying = true;
          } else if(scrollTop < elementOffsetTop - (winHeight * 0.4) && isPlaying !== false) {
            $element[0].pause();
            isPlaying = false;
          } else if(scrollTop > elementOffsetTop + (elementHieght * 0.5) && isPlaying !== false) {
            $element[0].pause();
            isPlaying = false;
          }
    //    }
      }).scroll();

    });

  };

  $(function() {
    setTimeout(function(){
      $('.lazy-video').scrollVideo();
    }, 1000);
  });

}(jQuery, this, document));